<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading Ticket by Status
    div#statuspie
</template>

<script>
import ticketService from '../../../service.js'
import { mapGetters } from "vuex";
export default {
  watch: {
    location() {
      this.getAllTicketByStatus()
    }
  },
  methods: {
    getAllTicketByStatus() {
      return ticketService.getAllTicketByStatus(this.location.storeID)
      .then(data => {
        if(data){
          let newData = []
          data.map(row => {
            newData.push({
              name: row.selector,
              y: row.statusCount,
              sliced: true,
            })
          })
          var HighChartPie = $('#statuspie');
          if (HighChartPie.length) {

            HighChartPie.highcharts({
              credits: false, // Disable HighCharts logo
              // colors: ['green', '#4a89dc', '#3bafda', '#8A1B1D'], // Set Colors
              chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
              },
              title: {
                  text: null
              },
              tooltip: {
                  pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
              },
              plotOptions: {
                pie: {
                  allowPointSelect: true,
                  cursor: 'pointer',
                  dataLabels: {
                      enabled: false
                  },
                  showInLegend: true
                }
              },
              series: [{
                type: 'pie',
                colorByPoint: true,
                name: 'Status',
                data: newData
              }]
            });
          }
        }
      })
    }
  },
  mounted() {
    this.getAllTicketByStatus()
  },
  computed: {
    ...mapGetters("location", ["location"]),
  },
  
}
</script>
